import { gql } from 'apollo-boost';

export const TRIGGER_AI_ORGANIZATION_BACKFILL = gql`
    mutation TriggerAiOrganizationBackfill($data: TriggerAiOrganizationBackfillInput!) {
        triggerAiOrganizationBackfill(data: $data) {
            success
            message
            job {
                id
                userId
                requestedByAdminId
                status
                messageLimit
                autoMove
                forceReprocess
                processedCount
                autoMovedCount
                suggestedOnlyCount
                skippedNoCreditsCount
                creditsCharged
                estimatedCredits
                startedAt
                completedAt
                errorMessage
                attempts
                nextRetryAt
                pipelineVersion
                createdAt
                updatedAt
            }
        }
    }
`;
